<template>
  <div class="container-fluid p-0">
     <div class="w-100 general-header">
        <p class="text-center pt-1 pb-1 m-0">{{title}}</p>
    </div>
    <div class = " p-2 ml-1 mr-1">
        <DocumentDetail 
          v-for="(document, index) in documents" :key="index"
          v-bind:name="document.name"
          v-bind:docURL="document.docURL"
          v-bind:block_chain="document.block_chain"
        ></DocumentDetail>
        <div class="form-group pt-5 ml-3 mr-3">
            <button type="button" class="btn-general" >
                {{title}}
            </button>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import DocumentDetail from '@/components/containerViews/containerDocsComponets/DocumentDetail'


export default {
  name: 'DownloadDocs',
  components: {
    DocumentDetail
  },
  props: {
    type: String,
  },
  data() {
    return {
        title: '',
        documents: [
      
        ]
    }
  },
  computed: {
    ...mapGetters("container",{
      container_id: 'container_id',
    }),
  },
  mounted () {
    this.setType()
  },
  methods: {
    setType: function () {
       switch (this.type) {
            case 'naviera-notify':
                this.title = 'Notificar a aduana'
                this.documents.push({name: 'Bill of Landing', docURL: '', block_chain: ''})
                break;
            case 'naviera-request-permission':
                this.title = 'Solicitar permiso de mercancía peligrosa'
                this.documents.push({name: 'Ficha Mer. Peligrosa', docURL: '', block_chain: ''})
                this.documents.push({name: 'Carta de Porte', docURL: '', block_chain: ''})
                break;
            case 'transportista':
                this.title = 'Entregar en terminal (contenedor lleno)'
                this.documents.push({name: 'Admítase', docURL: '', block_chain: ''})
                break;
            default:
                break;
      }
    }
  }
}
</script>

<style lang= "scss" >


</style>